var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"turnstile-widget"},[_c('div',{ref:"container",staticClass:"turnstile-container"}),(_vm.loadError)?_c('p',{staticClass:"turnstile-error"},[_vm._v("\n    Couldn’t load the security check. Refresh the page or disable any script blockers, then try again.\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }